import React, { useState } from 'react';
import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import './EmailContactActions.scss';

interface Props {
   email: string;
   subject?: string;
   emailActionLabel?: string;
   copyActionLabel?: string;
   compact?: boolean;
}

async function copyText(value: string) {
   if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      return;
   }
   const input = document.createElement('textarea');
   input.value = value;
   input.style.position = 'fixed';
   input.style.opacity = '0';
   document.body.appendChild(input);
   input.select();
   document.execCommand('copy');
   document.body.removeChild(input);
}

export default function EmailContactActions({ email, subject, emailActionLabel = 'Open email app', copyActionLabel = 'Copy email', compact = false }: Props) {
   const [copied, setCopied] = useState(false);
   const [isAddressVisible, setIsAddressVisible] = useState(false);
   const address = String(email || '').trim();
   if (!address) return null;
   const href = `mailto:${address}${subject ? `?subject=${encodeURIComponent(subject)}` : ''}`;
   const onCopy = async () => {
      try {
         await copyText(address);
         setCopied(true);
         window.setTimeout(() => setCopied(false), 2000);
      } catch (_) {
         setCopied(false);
      }
   };

   return <div className={`email-contact-actions${compact ? ' is-compact' : ''}`}>
      <div className='email-contact-actions__address'>
         {isAddressVisible
            ? <span>{address}</span>
            : <button type='button' className='email-contact-actions__reveal' onClick={() => setIsAddressVisible(true)}>Show email address</button>}
      </div>
      <div>
         <button type='button' className='email-contact-actions__email' onClick={() => window.location.assign(href)}><MailOutlineRoundedIcon />{emailActionLabel}</button>
         <button type='button' onClick={onCopy}><ContentCopyRoundedIcon />{copied ? 'Email copied' : copyActionLabel}</button>
      </div>
   </div>;
}
